import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
    root: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        animation: 'image-pulse-backdrop 2s infinite',
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0, 0, 0, 0.01)'
    },
    "@global": {
        "@keyframes image-pulse-backdrop": {
            "0%": {
                backdropFilter: 'blur(4px)'
            },
            "70%": {
                backdropFilter: 'blur(2px)'
            },
            "100%": {
                backdropFilter: 'blur(4px)'
            }
        }
    },
})

const ImageLoader = () => {
    const classes = useStyles();
    return <div className={classes.root} />
}

export default ImageLoader;